import { RouteNamesAuth } from 'routes/enum'
import { MenuItem } from './sideBar'
import {
  MenuCommunications,
  MenuClaims,
  MenuHome,
  MenuProcesses,
  MenuProducts,
  MenuProposals,
  MenuTrainings,
} from 'components/Icons'

export const brokersMenu: MenuItem[] = [
  {
    label: 'Dashboard',
    url: RouteNamesAuth.DASHBOARD,
    icon: () => <MenuHome size={16} />,
    submenu: null,
    brokerMaster: true,
    access: [0, 1, 2, 3, 4, 5],
  },
  {
    label: 'Produtos',
    url: '#',
    icon: () => <MenuProducts size={16} />,
    submenu: null,
    brokerMaster: true,
    access: [0, 1, 2, 3, 4, 5],
  },
  {
    label: 'Simuladores',
    url: '#',
    icon: () => <MenuProposals size={16} />,
    submenu: null,
    brokerMaster: false,
    access: [0, 1, 2, 3, 4, 5],
  },
  {
    label: 'Consultar',
    url: '#',
    icon: () => <MenuHome size={16} />,
    brokerMaster: true,
    access: [1, 2, 3, 4, 5],
    submenu: [
      {
        label: false,
        items: [
          {
            label: 'Apólices',
            url: RouteNamesAuth.POLICIES,
            access: [1, 2, 3, 4, 5],
          },
          {
            label: 'Cotações',
            url: RouteNamesAuth.QUOTATIONS,
            access: [1, 2, 3, 4, 5],
          },
          {
            label: 'Recibos',
            url: RouteNamesAuth.INVOICES,
            access: [1, 2, 3, 4, 5],
          },
        ],
      },
    ],
  },
  {
    label: 'Informações',
    url: '#',
    icon: () => <MenuProcesses size={16} />,
    brokerMaster: true,
    access: [0, 1, 2, 3, 4, 5],
    submenu: [
      {
        label: false,
        items: [
          {
            label: 'Pagamentos à Innovarisk',
            url: `${RouteNamesAuth.PAYMENTS.replace(
              ':slug',
              'pagamentos-a-innovarisk',
            )}`,
            access: [0, 1, 2, 3, 4, 5],
          },
          {
            label: 'Documentos',
            url: RouteNamesAuth.DOCUMENTS,
            access: [0, 1, 2, 3, 4, 5],
          },
          {
            label: 'Extrato de Conta',
            url: RouteNamesAuth.EXTRACTS,
            access: [2, 3, 4, 5],
          },
        ],
      },
    ],
  },
  {
    label: 'Campanhas',
    url: RouteNamesAuth.CAMPAIGNS,
    icon: () => <MenuCommunications size={16} />,
    brokerMaster: true,
    submenu: null,
    access: [0, 1, 2, 3, 4, 5],
  },
  {
    label: 'Sinistros',
    url: '#',
    icon: () => <MenuClaims size={16} />,
    brokerMaster: false,
    access: [0, 1, 2, 3, 4, 5],
    submenu: [
      {
        label: false,
        items: [
          {
            label: 'Participação de sinistro',
            url: `${RouteNamesAuth.CLAIMS_PROCESS.replace(
              ':slug',
              'participacao-de-sinistros',
            )}`,
            access: [0, 1, 2, 3, 4, 5],
          },
          {
            label: 'Estado dos sinistros',
            url: RouteNamesAuth.CLAIMS,
            access: [0, 1, 2, 3, 4, 5],
          },
        ],
      },
    ],
  },

  {
    label: 'Formações',
    url: '#',
    icon: () => <MenuTrainings size={16} />,
    brokerMaster: true,
    access: [0, 1, 2, 3, 4, 5],
    submenu: [
      {
        label: false,
        items: [
          {
            label: 'Em curso ou futuras',
            url: RouteNamesAuth.TRAININGS,
            access: [0, 1, 2, 3, 4, 5],
          },
          {
            label: 'Passadas',
            url: RouteNamesAuth.PAST_TRAININGS,
            access: [0, 1, 2, 3, 4, 5],
          },
          {
            label: 'Tutoriais',
            url: RouteNamesAuth.TUTORIALS,
            access: [0, 1, 2, 3, 4, 5],
          },
        ],
      },
    ],
  },
]
